import { React, useEffect, useRef } from 'react'
import CurrencyFormat from 'react-currency-format'

import Productimage from './productimage';
import { useDispatch, useSelector } from 'react-redux';
// Importing actions from  cart.slice.js
import { changeInCart, removeFromCart } from '../../redux/cart.slice';
import { change_price_based_on_discount_table } from '../../lib/discounts'
import * as ga from '../../lib/ga'

import Stock from './stock'

function MiniCartItem({ item, type }) {

    const dispatch = useDispatch();
    const voucher = useSelector((state) => state.voucher);
    const incrementQuantityBtn = useRef(null)

    const set_quantity_and_price = (quantity_to_add) => {
        // take a copy of the state and update the quantity
        let change_variation = {
            ...item,
            quantity: Number(quantity_to_add),
            add_quantity: Number(quantity_to_add),
        }

        // change prices if needed
        change_variation = change_price_based_on_discount_table(change_variation, voucher)
        // write it back
        dispatch(changeInCart(change_variation))
    }

    const increment_quantity_to_add = (event) => {
        if (item.backorder == 1) {
            if (Number(item.quantity) >= 1 && Number(item.quantity) < 1000) {
                set_quantity_and_price(Number(item.quantity) + Number(1))
            }
            if (Number(item.quantity) < 1) {
                set_quantity_and_price(1)
            }
            if (Number(item.quantity) >= 999) {
                set_quantity_and_price(999)
            }
        } else {
            if(Number(item.quantity) + Number(1) ==  Number(item.available_quantity)){
                incrementQuantityBtn.current.disabled = true;
            }
            if (Number(event.target.value) >= Number(item.quantity)) {
                set_quantity_and_price(Number(item.quantity) + Number(1))
            }
            if (Number(item.quantity) >= 1 && Number(item.quantity) <= 1000) {
                set_quantity_and_price(Number(item.quantity) + Number(1))
            }
            if (Number(item.quantity) < 1) {
                set_quantity_and_price(1)
            }
            if (Number(item.quantity) >= 999) {
                set_quantity_and_price(999)
            }
        }
    }

    const change_quantity_input = (event) => {
        if (item.backorder == 1) {
            if (Number(event.target.value) >= 1 && Number(event.target.value) < 1000) {
                set_quantity_and_price(Number(event.target.value))
            }
            if (Number(event.target.value) < 1) {
                set_quantity_and_price(1)
            }
            if (Number(event.target.value) >= 1000) {
                set_quantity_and_price(999)
            }
        } else {
            if(Number(event.target.value) <= Number(item.available_quantity)){
                if (Number(event.target.value) >= Number(item.quantity)) {
                    set_quantity_and_price(Number(item.quantity))
                }
                if (Number(event.target.value) >= 1 && Number(event.target.value) < 1000) {
                    set_quantity_and_price(Number(event.target.value))
                }
                if (Number(event.target.value) < 1) {
                    set_quantity_and_price(1)
                }
                if (Number(event.target.value) >= 1000) {
                    set_quantity_and_price(999)
                }
            }
        }
    }

    const decrement_quantity_to_add = (event) => {
        if (item.backorder == 1) {
            if (Number(item.quantity) > 1 && Number(item.quantity) < 1000) {
                set_quantity_and_price(Number(item.quantity) - Number(1))
            }
            if (Number(item.quantity) <= 1) {
                set_quantity_and_price(1)
            }
            if (Number(item.quantity) >= 1000) {
                set_quantity_and_price(999)
            }
        } else {
            if (Number(event.target.value) >= Number(item.quantity)) {
                set_quantity_and_price(Number(item.quantity) - Number(1))
            }
            if (Number(item.quantity) > 1 && Number(item.quantity) < 1000) {
                incrementQuantityBtn.current.disabled = false;
                set_quantity_and_price(Number(item.quantity) - Number(1))
            }
            if (Number(item.quantity) <= 1) {
                set_quantity_and_price(1)
            }
            if (Number(item.quantity) >= 1000) {
                set_quantity_and_price(999)
            }
        }
    }

    const remove_from_cart = (item) => {
        dispatch(removeFromCart(item.id))
        ga.remove_from_cart(item)
    }

    useEffect(() => {

        // do the initial setting of the variation data
        let change_variation = {
            ...item,
        }
        // change prices if needed
        change_variation = change_price_based_on_discount_table(change_variation, voucher)
        // write it back
        dispatch(changeInCart(change_variation))

        if (change_variation.backorder == 0) {
            if(Number(change_variation.quantity) ==  Number(change_variation.available_quantity)){
                incrementQuantityBtn.current.disabled = true;
            }
        }

    }, [voucher]);

    return (
        <>

            <div className="flex">
                <div className="flex-grow">
                    <div className="w-full flex self-center relative">
                        <div className="rounded absolute w-16 h-16 self-start border border-gray-200 bg-white">
                            <Productimage item={item}></Productimage>
                        </div>
                        <div className="flex flex-col flex-grow space-y-1 ml-20">

                            <span className="text-gray-900 font-medium">
                                {item.name}
                            </span>

                            <Stock variation={item}></Stock>

                            <div className="flex lg:items-end space-x-3">
                                <div className="flex flex-col">
                                    <div className="font-medium text-gray-900">
                                        <CurrencyFormat decimalScale={2} value={(item.price_ex_vat) / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                                    </div>
                                    <div className="text-gray-500 text-xxs font-medium">(EX. VAT)</div>
                                </div>
                                <div className="flex flex-col">
                                    <div className="font-bold text-gray-900">
                                        <CurrencyFormat decimalScale={2} value={(item.price_inc_vat) / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                                    </div>
                                    <div className="text-gray-500 text-xxs font-medium">(INC. VAT)</div>
                                </div>
                            </div>

                            <div className="flex w-40 pt-2">
                                <button
                                    onClick={(event) => decrement_quantity_to_add(event)}
                                    className="relative z-10 cursor-pointer rounded-tl rounded-bl bg-white flex items-center justify-center border-l border-t border-b border-gray-300 px-4 hover:bg-gray-100 active:bg-gray-200 focus:ring-2 focus:ring-brand-tertiary transition duration-150 ease-in-out"
                                >
                                    <i className="fas fa-minus"></i>
                                </button>
                                <input
                                    pattern="[0-9]+"
                                    type="text"
                                    onChange={(event) => change_quantity_input(event)}
                                    className="appearance-none block w-full py-3 px-0 border border-gray-300 text-center text-gray-800 focus:not-italic p-4 hover:border-brand-secondary active:border-brand-tertiary transition-all focus:outline-none focus:border-brand-tertiary focus:ring-2 focus:ring-inset focus:ring-brand-tertiary"
                                    value={item.quantity}
                                />
                                <button
                                    onClick={(event) => increment_quantity_to_add(event)}
                                    className="cursor-pointer rounded-tr rounded-br bg-white flex items-center justify-center border-r border-t border-b border-gray-300 px-4 hover:bg-gray-100 active:bg-gray-200 focus:ring-2 focus:ring-brand-tertiary transition duration-150 ease-in-out"
                                    ref={incrementQuantityBtn}
                                >
                                    <i className="fas fa-plus"></i>
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex-grow-0 self-start">
                    <button type="button" onClick={() => remove_from_cart(item)} className="rounded -mt-1 p-2 cursor-pointer text-lg text-red-600 hover:text-red-800 active:text-red-400 focus:ring-2 focus:ring-brand-tertiary transition duration-150 ease-in-out">
                        <i className="fas fa-fw fa-trash-alt"></i>
                    </button>
                </div>
            </div>
            {(voucher && voucher[0] && voucher[0].data && item.dis != null) ? (
                <div className="flex">
                    <div className="w-full text-xs relative bg-emerald-50 p-2 text-emerald-900 mb-5">
                        <span>Voucher Applied</span>
                        {(voucher[0].data.discount_percent) ? (voucher[0].data.discount_percent + '% Off') : ('')}
                        {(voucher[0].data.discount_amount) ? (
                            <>
                                <CurrencyFormat decimalScale={2} value={voucher[0].data.discount_amount / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} className="ml-2 mr-2" />
                                <span>Off</span>
                            </>
                        ) : ('')}
                    </div>
                </div>
            ) : ('')}


        </>
    );
}

export default MiniCartItem;